module.exports = __webpack_public_path__ + "bg-header-menu-3-sz2.jpg";